import { AccessControlDto, KnownHubDtoType, SectionDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';
import { Section } from './section.model';
import { Space } from './space.model';
import { Space as SpaceIcon } from '../../../ui/components/pure/icons/Space.icon';

export class SectionDetails extends Section {
  public readonly spaces: Space[];
  public readonly accessControls: AccessControlDto[];

  constructor(section: SectionDto, spaces: Space[], accessControls: AccessControlDto[], hubType: KnownHubDtoType) {
    super(section, hubType);
    this.spaces = spaces;
    this.accessControls = accessControls;
  }

  public get spacesCount(): number {
    return this.spaces.length;
  }

  public get spacesCountBySize() {
    return this.spaces.reduce(
      (acc, space) => {
        if (space.isKiosk) {
          acc['kiosk'] = {
            count: 1,
            Icon: space.icon
          };
          return acc;
        }
        acc['space'].count++;
        return acc;
      },
      {
        space: {
          Icon: SpaceIcon,
          count: 0
        }
      } as Record<string, { Icon: SVGIconComponent; count: number }>
    );
  }

  public get spacesCountDescription(): string {
    const spaceWord = this.spacesCount === 1 ? 'space' : 'spaces';
    return `${this.spacesCount} ${spaceWord}`;
  }

  // For Parcel Room MVP we assume there is either 0 or 1 access control per section
  public get accessControl(): AccessControlDto | undefined {
    return this.accessControls[0];
  }
}
